<template>
  <div class="selector-filters">
    <label class="selector-field">
      <span>店铺</span>
      <el-select
        :value="shopId"
        clearable
        size="small"
        placeholder="选择抖店"
        aria-label="选择抖店"
        popper-class="product-selector-dialog__popper"
        @change="$emit('shop-change', $event)">
        <el-option
          v-for="shop in shops"
          :key="shop.mer_shop_id"
          :value="Number(shop.mer_shop_id)"
          :label="shop.shop_name" />
      </el-select>
    </label>
    <label class="selector-field">
      <span>商品分类</span>
      <doudian-category-cascader v-model="value.category_id" :categories="categories" size="small" />
    </label>
    <label class="selector-field">
      <span>商品 ID</span>
      <el-input
        v-model="value.platform_product_id"
        size="small"
        placeholder="抖店商品ID"
        aria-label="抖店商品ID"
        @keyup.enter.native="$emit('query')" />
    </label>
    <label class="selector-field">
      <span>商品标题</span>
      <el-input
        v-model="value.product_title"
        size="small"
        placeholder="商品标题"
        aria-label="商品标题"
        @keyup.enter.native="$emit('query')" />
    </label>
    <label class="selector-field">
      <span>创建时间</span>
      <el-date-picker
        v-model="value.created_at"
        type="datetimerange"
        size="small"
        popper-class="product-selector-dialog__popper"
        value-format="yyyy-MM-dd HH:mm:ss"
        start-placeholder="开始"
        end-placeholder="结束" />
    </label>
    <label class="selector-field">
      <span>平台状态</span>
      <el-select
        v-model="value.tab_status"
        clearable
        size="small"
        placeholder="抖店平台状态"
        popper-class="product-selector-dialog__popper">
        <el-option label="全部" value="" />
        <el-option label="已上架" value="selling" />
        <el-option label="仓库中" value="warehouse" />
        <el-option label="草稿箱" value="draft" />
        <el-option label="审核中" value="reviewing" />
        <el-option label="审核不通过" value="review_rejected" />
      </el-select>
    </label>
    <button class="selector-query" @click="$emit('query')">查询</button>
  </div>
</template>

<script>
import DoudianCategoryCascader from '@/components/DoudianCategoryCascader'

export default {
  components: { DoudianCategoryCascader },
  props: {
    value: { type: Object, required: true },
    shopId: { type: [String, Number], default: '' },
    shops: { type: Array, default: () => [] },
    categories: { type: Array, default: () => [] }
  }
}
</script>

<style scoped>
.selector-filters {
  display: grid;
  flex: 1;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  align-items: end;
  gap: 8px 10px;
  min-width: 0;
}
.selector-field {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
  margin: 0;
}
.selector-field > span {
  color: #667085;
  font-size: 11px;
  line-height: 16px;
}
.selector-field > .el-input,
.selector-field > .el-select,
.selector-field > .el-date-editor,
.selector-field > .doudian-category-cascader {
  width: 100%;
  min-width: 0;
}
.selector-filters ::v-deep .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  border-radius: 6px;
  font-size: 11px !important;
}
.selector-filters ::v-deep .el-input__icon {
  line-height: 26px;
}
.selector-filters ::v-deep .cascader-input.is-small {
  height: 28px;
  box-sizing: border-box;
  border-radius: 6px;
  font-size: 11px;
}
.selector-filters ::v-deep .el-range-editor {
  display: flex;
  align-items: center;
  padding: 0 6px;
}
.selector-filters ::v-deep .el-range-input {
  flex: 1;
  width: 0;
  min-width: 0;
  font-size: 11px;
}
.selector-filters ::v-deep .el-range-separator {
  width: 12px;
  padding: 0;
  line-height: 26px;
}
.selector-query {
  justify-self: start;
  height: 28px;
  min-width: 72px;
  padding: 0 14px;
  border: 1px solid #1677ff;
  border-radius: 6px;
  background: #1677ff;
  color: #fff;
  font: inherit;
  font-size: 11px;
  cursor: pointer;
}
.selector-query:hover {
  background: #4096ff;
  border-color: #4096ff;
}
@media (max-width: 680px) {
  .selector-filters {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }
}
</style>
